module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b5af7a55bcb8596890e91b0e9b856f3c.png";